<template>
  <transition name="fade">
    <div :class="classes">
      <div :class="mainClasses">
        <span :class="dotClasses"></span>
        <div :class="textClasses">
          <slot></slot>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import { oneOf } from './Utils';

const prefixCls = 'xm-spin';

export default {
  name: 'xm-spin',
  props: {
    size: {
      validator(value) {
        return oneOf(value, ['small', 'large']);
      }
    },
    fix: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showText: false
    };
  },
  computed: {
    classes() {
      return [
        `${prefixCls}`,
        {
          [`${prefixCls}-${this.size}`]: !!this.size,
          [`${prefixCls}-fix`]: this.fix,
          [`${prefixCls}-show-text`]: this.showText,
        }
      ];
    },
    mainClasses() {
      return `${prefixCls}-main`;
    },
    dotClasses() {
      return `${prefixCls}-dot`;
    },
    textClasses() {
      return `${prefixCls}-text`;
    }
  },
  mounted() {
    this.showText = this.$slots.default !== undefined;
  }
};
</script>

<style lang="less">
@import '../core/variables.less';
@import '../core/size.less';

@spin-dot-size-small: 0.24rem;
@spin-dot-size: 0.4rem;
@spin-dot-size-large: 0.64rem;

.xm-spin {
  background-color: transparent;
  vertical-align: middle;
  text-align: center;

  &-dot {
    position: relative;
    display: block;
    border-radius: 50%;
    background-color: @color-primary;
    .square(@spin-dot-size);
    animation: ani-spin-bounce 1s 0s ease-in-out infinite;
  }

  &-large &-dot {
    .square(@spin-dot-size-large);
  }

  &-small &-dot {
    .square(@spin-dot-size-small);
  }

  &-fix {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: @zindex-spin;
    display: table;
    .square(100%);
  }

  &-fix &-main {
    display: table-cell;
    background-color: transparent;
    vertical-align: middle;
    .square(inherit);
  }

  &-fix &-dot {
    display: inline-block;
  }

  &-text,
  &-show-text &-dot {
    display: none;
  }

  &-show-text &-text {
    display: block;
    height: 1.2rem;
  }
}

@keyframes ani-spin-bounce {
  0% {
    transform: scale(0);
  }

  100% {
    transform: scale(1);
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Spin.vue